import actions from './actions';

export default {
  actions,
  suffix: 'newsLetter',
  state: () => ({})
};
